var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.eventsData.series),function(series){return _c('div',{key:series.name,staticClass:"d-flex flex-fill"},[_c('div',{staticClass:"card m-1",staticStyle:{"width":"100%"}},[_c('events-attendance-chart',{attrs:{"series-data":series,"background":'#243447'}})],1)])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ed8b48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/events/EventDashboard.vue
// module id = null
// module chunks = 